import { admin } from '@/api'
import { setCookie, getCookie } from '@/utils/cookie'

const MAINTAINCE_DATA = () => {
  return {
    maintaince: {
      adminId: '',
      token: '',
    },
    updateData: {
      mtid: '',
      mt_id: '',
      password: '',
      name: '',
      phone: '',
      wid: '',
      tid: '',
      team_name: '',
    },

    patientData: {
      id: '',
      number: '',
      name: '',
      ssn: '',
      anamnesis: '',
      ward_name: '',
      wid: '',
      room_name: '',
      rid: '',
      professor: '',
      resident: '',
      hospitalization: '',
      bedsore: '',
      discharge: '',
      recovery: '',
    },
    patientPage: {
      startIndex: '',
      pageCnt: '',
    },
    list: {
      ward: [],
      team: [],
      room: [],
    },
  }
}

const state = {
  maintaince: {
    adminId: getCookie('adminId') || '',
    token: getCookie('token') || '',
  },

  updateData: {
    mtid: '',
    mt_id: '',
    password: '',
    name: '',
    phone: '',
    wid: '',
    tid: '',
    team_name: '',
  },

  patientData: {
    id: '',
    number: '',
    name: '',
    ssn: '',
    anamnesis: '',
    ward_name: '',
    wid: '',
    room_name: '',
    rid: '',
    professor: '',
    resident: '',
    hospitalization: '',
    bedsore: '',
    discharge: '',
    recovery: '',
  },

  patientPage: {
    startIndex: 0,
    pageCnt: 10,
  },
  list: {
    ward: [],
    team: [],
    room: [],
  },
}

const mutations = {
  INIT_DATA(state) {
    state.maintaince = MAINTAINCE_DATA().maintaince
    state.updateData = MAINTAINCE_DATA().updateData
    state.patientData = MAINTAINCE_DATA().patientData
    state.list = MAINTAINCE_DATA().list
    state.patientPage = MAINTAINCE_DATA().patientPage
  },
  INIT_UPDATE_MEDICAL_DATA(state) {
    state.updateData = MAINTAINCE_DATA().updateData
  },
  INIT_UPDATE_PATIENT_DATA(state) {
    state.patientData = MAINTAINCE_DATA().patientData
  },
  INIT_UPDATE_MEDICAL_PASS(state) {
    state.patientData.password = MAINTAINCE_DATA().updateData.password
  },
  SET_LOGIN_RESPONSE(state, loginResponse) {
    state.maintaince.adminId = loginResponse.adminId
    state.maintaince.token = loginResponse.token
  },
  SET_MEDICAL_UPDATE(state, updateResponse) {
    state.updateData.mt_id = updateResponse.mt_id
    state.updateData.mtid = updateResponse.mtid
    state.updateData.password = updateResponse.password
    state.updateData.name = updateResponse.name
    state.updateData.phone = updateResponse.phone
    state.updateData.tid = updateResponse.tid
    state.updateData.team_name = updateResponse.team_name
    state.updateData.wid = updateResponse.wid
  },
  SET_MEDICAL_UPDATE_ID(state, id) {
    state.updateData.mt_id = id
  },
  SET_MEDICAL_UPDATE_NAME(state, name) {
    state.updateData.name = name
  },
  SET_MEDICAL_UPDATE_PHONE(state, phone) {
    state.updateData.phone = phone
  },
  SET_MEDICAL_UPDATE_PASS(state, password) {
    state.updateData.password = password
  },
  SET_MEDICAL_UPDATE_WID(state, wid) {
    state.updateData.wid = wid
  },
  SET_MEDICAL_UPDATE_TID(state, tid) {
    state.updateData.tid = tid
  },
  SET_MEDICAL_UPDATE_TNAME(state, team_name) {
    state.updateData.team_name = team_name
  },
  SET_PATIENT_UPDATE(state, updateResponse) {
    state.patientData = updateResponse
    // state.patientData.number = updateResponse.number
    // state.patientData.name = updateResponse.name
    // state.patientData.ssn = updateResponse.ssn
    // state.patientData.anamnesis = updateResponse.anamnesis
    // state.patientData.ward_name = updateResponse.ward_name
    // state.patientData.wid = updateResponse.wid
    // state.patientData.room_name = updateResponse.room_name
    // state.patientData.rid = updateResponse.rid
    // state.patientData.professor = updateResponse.professor
    // state.patientData.resident = updateResponse.resident
    // state.patientData.hospitalization = updateResponse.hospitalization
    // state.patientData.bedsore = updateResponse.bedsore
    // state.patientData.discharge = updateResponse.discharge
    // state.patientData.recovery = updateResponse.recovery
  },
  SET_PATIENT_UPDATE_WID(state, wid) {
    state.patientData.wid = wid
  },
  SET_PATIENT_UPDATE_RID(state, rid) {
    state.patientData.rid = rid
  },
  SET_PATIENT_UPDATE_RNAME(state, room_name) {
    state.patientData.room_name = room_name
  },
  SET_PATIENT_UPDATE_DISCHARGE(state, discharge) {
    state.patientData.discharge = discharge
  },
  SET_PATIENT_UPDATE_RECOVERY(state, recovery) {
    state.patientData.recovery = recovery
  },
  SET_PATIENT_UPDATE_PROFESSOR(state, professor) {
    state.patientData.professor = professor
  },
  SET_PATIENT_UPDATE_RESIDENT(state, resident) {
    state.patientData.resident = resident
  },
  SET_PATIENT_UPDATE_NUMBER(state, number) {
    state.patientData.number = number
  },
  SET_PATIENT_UPDATE_NAME(state, name) {
    state.patientData.name = name
  },
  SET_PATIENT_UPDATE_SSN(state, ssn) {
    state.patientData.ssn = ssn
  },
  SET_PATIENT_UPDATE_HOSPITALIZATION(state, hospitalization) {
    state.patientData.hospitalization = hospitalization
  },
  SET_PATIENT_UPDATE_BEDSORE(state, bedsore) {
    state.patientData.bedsore = bedsore
  },
  SET_PATIENT_UPDATE_ANAMNESIS(state, anamnesis) {
    state.patientData.anamnesis = anamnesis
  },
  SET_PATIENT_PAGE_CNT(state, pageCnt) {
    state.patientPage.pageCnt = pageCnt
  },
  SET_PATIENT_PAGE_INDEX(state, startIndex) {
    state.patientPage.startIndex = startIndex
  },
  SET_WARD_LIST(state, response) {
    state.list.ward = response
  },
  SET_TEAM_LIST(state, response) {
    state.list.team = response
  },
  SET_ROOM_LIST(state, response) {
    state.list.room = response
  },
}

const getters = {
  GET_ADMIN_NAME: (state) => state.maintaince.adminId,
  GET_ADMIN_TOKEN: (state) => state.maintaince.token,
}

const actions = {
  LOGIN({ commit }, adminData) {
    return admin.login(adminData).then((data) => {
      if (data.message && data.message === 'success') {
        let resData = {
          adminId: data.response.admin_id,
          token: data.response.token,
        }
        setCookie('adminId', data.response.admin_id, {
          secure: true,
          expires: 30,
        })
        setCookie('token', data.response.token, { secure: true, expires: 30 })
        // console.log(resData)
        commit('SET_LOGIN_RESPONSE', resData)
      }
      // console.log(data)
      return data
    })
  },
  LOGOUT({}) {
    return admin.logout().then((data) => {
      // console.log(data)
      return data
    })
  },
  FETCH_MEDICAL_READ({}, adminData) {
    return admin.medicalRead(adminData).then((data) => {
      // console.log(data)
      return data
    })
  },
  FETCH_MEDICAL_READ_SEARCH({}, adminData) {
    return admin.medicalReadSearch(adminData).then((data) => {
      // console.log(data)
      return data
    })
  },
  UPDATE_MEDICAL_DETAIL({}, adminData) {
    return admin.medicalUpdate(adminData).then((data) => {
      // console.log(data)
      return data
    })
  },
  CREATE_MEDICAL_DETAIL({}, adminData) {
    return admin.medicalCreate(adminData).then((data) => {
      // console.log(data)
      return data
    })
  },
  DELETE_MEDICAL_LIST({}, adminData) {
    return admin.medicalDelete(adminData).then((data) => {
      // console.log(data)
      return data
    })
  },
  FETCH_PATIENT_READ({}, adminData) {
    return admin.patientRead(adminData).then((data) => {
      // console.log(data)
      return data
    })
  },
  FETCH_PATIENT_READ_SEARCH({}, adminData) {
    return admin.patientRead(adminData).then((data) => {
      // console.log(data)
      return data
    })
  },
  UPDATE_PATIENT_DETAIL({}, adminData) {
    return admin.patientUpdate(adminData).then((data) => {
      // console.log(data)
      return data
    })
  },
  CREATE_PATIENT_DETAIL({}, adminData) {
    return admin.patientCreate(adminData).then((data) => {
      // console.log(data)
      return data
    })
  },
  FETCH_WARD_LIST({ commit }) {
    return admin.wardList().then((data) => {
      if (data.message && data.message === 'success') {
        // console.log(data.response.list)
        commit('SET_WARD_LIST', data.response?.ward_list ?? [])
      }
      return data.response.list
    })
  },
  FETCH_TEAM_LIST({ commit }, adminData) {
    return admin.teamList(adminData).then((data) => {
      if (data.message && data.message === 'success') {
        // console.log(data.response.list)
        commit('SET_TEAM_LIST', data.response?.team_list ?? [])
      }
      return data.response.list
    })
  },
  FETCH_ROOM_LIST({ commit }, adminData) {
    return admin.roomList(adminData).then((data) => {
      if (data.message && data.message === 'success') {
        // console.log(data.response.list)
        commit('SET_ROOM_LIST', data.response.room_list)
      }
      return data.response.list
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
// export default { actions }
